export default "/fonts/vendor/katex/dist/KaTeX_Main-Regular.woff?4f35fbcc9ee8614c2bcc8c28314db234";